import { ADD_AUTOFILL } from './../../action-types/bookproperties';

export const STATE_KEY = 'autofill';

export const autofill = (state = false, action) => {
  switch (action.type) {
    case ADD_AUTOFILL: {
      return action.status;
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/bookproperties/autofill.js